// Reproduces _cta.html as a React component, shared by the legacy v2 homepage
// and the order-lookup page (both reproduced the same "Transform your Bedroom™
// Today." CTA block verbatim).
import { Immutable } from "immer";
import React from "react";
import { jt, t } from "ttag";

type IProps = Immutable<{
    mattressUrl: string;
}>;

export const HomepageCTA = (props: IProps): React.JSX.Element => {
    // Hoist the <strong> element so jt's extractor sees a plain identifier, not
    // a JSX expression, inside the ${...} interpolation.
    const bedStrong = <strong key="bed">{t`Bed`}</strong>;
    return (
        <section className="cta-block stitch-bg">
            <div className="main-container">
                <h2>{jt`Transform your ${bedStrong}room™ Today.`}</h2>
                <a
                    className="button al-buy-now-btn"
                    href={props.mattressUrl}
                    id="buy-now-btn"
                >
                    {t`Buy Now`}
                </a>
            </div>
        </section>
    );
};
